import { TFunction } from '@mint-lib/i18n';
import z from 'zod';

export const FlowTypesEnum = z.enum(['flight']);
export const FlowStatusesEnum = z.enum([
  'active',
  'inactive',
  'scheduled',
  'ended',
]);
export const EntityTypesEnum = z.enum(['user', 'role']);
export const OperationTypesEnum = z.enum(['and', 'or', 'then']);

export type FlowTypes = z.infer<typeof FlowTypesEnum>;
export type FlowStatuses = z.infer<typeof FlowStatusesEnum>;
export type EntityTypes = z.infer<typeof EntityTypesEnum>;
export type OperationTypes = z.infer<typeof OperationTypesEnum>;

export const getMapLabelByFlowType = (
  t: TFunction,
): Record<FlowTypes, string> => {
  return {
    [FlowTypesEnum.enum.flight]: t('Flight'),
  };
};

export const getMapLabelByEntityType = (
  t: TFunction,
): Record<EntityTypes, string> => {
  return {
    [EntityTypesEnum.enum.user]: t('Users'),
    [EntityTypesEnum.enum.role]: t('Roles'),
  };
};

export const getMapValueFieldLabelByEntityType = (
  t: TFunction,
): Record<EntityTypes, string> => {
  return {
    [EntityTypesEnum.enum.user]: t('User'),
    [EntityTypesEnum.enum.role]: t('Role'),
  };
};

export const getMapLabelByOperationType = (
  t: TFunction,
): Record<OperationTypes, string> => {
  return {
    [OperationTypesEnum.enum.and]: t('And'),
    [OperationTypesEnum.enum.or]: t('Or'),
    [OperationTypesEnum.enum.then]: t('Then'),
  };
};

export const getMapChipMetaByFlowStatus = (t: TFunction) => {
  return {
    [FlowStatusesEnum.enum.active]: {
      label: t('Active'),
      variant: 'outline',
      color: 'primary',
    },
    [FlowStatusesEnum.enum.inactive]: {
      label: t('Inactive'),
      variant: 'outline',
      color: 'secondary',
    },
    [FlowStatusesEnum.enum.scheduled]: {
      label: t('Scheduled'),
      variant: 'outline',
      color: 'info',
    },
    [FlowStatusesEnum.enum.ended]: {
      label: t('Ended'),
      variant: 'outline',
      color: 'silver',
    },
  } as const;
};

export const READONLY_FLOW_STATUSES: FlowStatuses[] = [
  FlowStatusesEnum.enum.scheduled,
  FlowStatusesEnum.enum.ended,
];

export const PENDING_REQUEST_NOTIFICATION = {
  DEFAULT_FREQUENCY_DAYS: 2,
  MIN_FREQUENCY_DAYS: 1,
  MAX_FREQUENCY_DAYS: 99,
} as const;
export const APPROVAl_FLOW_FORM_ID = 'approval-flow-form';
